import React from 'react';
import { Routes, Route } from 'react-router-dom';

import PageNotFound from 'pages/pageNotFound';
import TrackingIndex from 'pages/tracking';
import TrackingDetail from 'pages/tracking/detail';
import ContactVerification from 'pages/tasksRescheduling/contactVerification';
import EditTasksRescheduling from 'pages/tasksRescheduling/editTasksRescheduling';

const AppRoutes = () => (
  <Routes>
    <Route element={<TrackingIndex />} path="/" />
    <Route element={<TrackingIndex />} path="/:domain" />
    <Route element={<TrackingDetail />} path="/:domain/:detail" />
    <Route element={<ContactVerification />} path="/:domain/:detail/verify" />
    <Route element={<EditTasksRescheduling />} path="/:domain/:detail/reschedule" />

    <Route element={<PageNotFound />} path="*" />
  </Routes>
);

export default AppRoutes;
